/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env';

@Injectable({
  providedIn: 'root'
})
export class CepService {

  constructor(
    private http: HttpClient
  ) { }

  getCepDetails(component_id, cep)  {
    return this.http.post(`${environment.API}/applyment/cep`, {
      component_id: component_id,
      cep: this.formatCep(cep)
    });
  }
  
  private formatCep(cep:string) {
    return cep.replace('-', '');
  }
}
